import React from 'react';

import { EMPTY_ARRAY } from 'common/constants';

import { ListCollapse } from '../ListCollapse/ListCollapse';
import { ListItemIcon } from 'shared/components';
import {
  IconButton,
  Menu,
  MenuItem,
  CircularProgress
} from 'e100-react-components';
import { Search } from '../Search/Search';
import { EmptyItemsMessage } from './EmptyItemsMessage/EmptyItemsMessage';
import { EmptyFilteredItemsMessage } from './EmptyFilteredItemsMessage/EmptyFilteredItemsMessage';
import { FavouriteBrandsDeleteModal, FavouriteBrandsAddSnackbar } from 'features/brands';

import { useIntl } from 'react-intl';
import {
  useBoolState,
  useShowMenu
} from 'common/hooks';
import { useStyles } from './styles';
import { useLoadFavouriteBrands } from '../../../hooks/useLoadFavouriteBrands';
import {
  useSelectedFavouriteBrandContext,
  useFilterContext
} from '../../../context';
import {
  useAddFavouriteBrand,
  useDeleteFavouriteBrand,
  useFilteredFavouriteBrands,
  useShowFavouriteStationsActions
} from '../../../hooks';
import {
  useFavouriteBrands,
  useIsAddingFavouriteBrandsLoading,
  useIsDeletingFavouriteBrandsLoading
} from 'entities/brands';
import { useFilteredBrandsByExistBrandList } from 'store/features/directories';

export const FavouriteBrands = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const loadFavouriteBrands = useLoadFavouriteBrands();
  const isAddingFavouriteBrandsLoading = useIsAddingFavouriteBrandsLoading();
  const isDeletingFavouriteBrandsLoading = useIsDeletingFavouriteBrandsLoading();
  const showFavouriteStationsActions = useShowFavouriteStationsActions();
  const {
    selectedFavouriteBrand,
    setSelectedFavouriteBrand
  } = useSelectedFavouriteBrandContext();
  const { anchorEl, onShowMenu, onCloseMenu } = useShowMenu();
  const [ showSearch, toogleShowSearh,, hideSearch ] = useBoolState(false);
  const [ showDeleteModal, toogleShowDeleteModal,, hideDeleteModal ] = useBoolState(false);
  const filteredFavouriteBrands = useFilteredFavouriteBrands();
  const { searchString } = useFilterContext();
  const favouriteBrands = useFavouriteBrands() || EMPTY_ARRAY;
  const filteredBrandsByExistBrandList = useFilteredBrandsByExistBrandList(favouriteBrands);
  const addFavouriteBrand = useAddFavouriteBrand();
  const deleteFavouriteBrand = useDeleteFavouriteBrand();

  return (
    <>
      <ListCollapse
        title={formatMessage({ id: 'favouriteBrands' })}
        action={
          isAddingFavouriteBrandsLoading
          ? <CircularProgress size={22} classes={{ root: classes.circularProgress }} />
          : !searchString.length && showFavouriteStationsActions
            ? <IconButton kind={'add'} onClick={toogleShowSearh} />
            : null
        }
        classes={{
          root: classes.root
        }}
      >
        {
          showSearch && !searchString.length && (
            <Search
              loadOptions={loadFavouriteBrands}
              onChange={async (_: any, { value: { billingId, title } }: any) => {
                hideSearch();
                addFavouriteBrand(billingId, title);
              }}
              placeholder={formatMessage({ id: 'findBrand' })}
              renderOption={({ value }: any) => value.title}
              defaultOptions={filteredBrandsByExistBrandList}
            />
          )
        }
        {
          filteredFavouriteBrands.map((filteredFavouriteBrand) => {
            const {
              billingId,
              title
            } = filteredFavouriteBrand;

            return (
              <ListItemIcon
                key={billingId}
                title={title}
                icon={'brand'}
                action={
                  isDeletingFavouriteBrandsLoading && selectedFavouriteBrand?.billingId === billingId
                  ?
                    <CircularProgress
                      size={22}
                      classes={{ root: classes.circularProgress }}
                    />
                  : showFavouriteStationsActions && <IconButton
                      kind={'moreVert'}
                      onClick={(event) => {
                        setSelectedFavouriteBrand(filteredFavouriteBrand);
                        onShowMenu(event);
                      }}
                    />
                }
              />
            );
          })
        }
        <EmptyItemsMessage />
        <EmptyFilteredItemsMessage />
      </ListCollapse>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={onCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={async () => {
            toogleShowDeleteModal();
            onCloseMenu();
          }}
        >
          {formatMessage({ id: 'deleteFromFavorites' })}
        </MenuItem>
      </Menu>
      <FavouriteBrandsDeleteModal
        open={showDeleteModal}
        onOk={async () => {
          if (selectedFavouriteBrand) {
            deleteFavouriteBrand(`${selectedFavouriteBrand.billingId}`, selectedFavouriteBrand.title);
            hideDeleteModal();
          }
        }}
        onCancel={hideDeleteModal}
      />
      <FavouriteBrandsAddSnackbar />
    </>
  );
};
